import { createContext, useContext, useEffect, useReducer, useCallback, memo } from "react";
import { useRouter } from "next/router";
import styles from "@/styles/Copyrights.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const CopyrightsContext = /*#__PURE__*/createContext({
  copyrights: [],
  setCopyrights: () => null,
  resetCopyrights: () => null
});
CopyrightsContext.displayName = "CopyrightsContext";
const initializeValue = [];
const reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initializeValue;
    case "add":
      const newState = [...new Set(state.concat(action.value))];
      return newState.filter(Boolean);
    default:
      return state;
  }
};
export function CopyrightsProvider(_ref) {
  let {
    children
  } = _ref;
  const {
    0: copyrights,
    1: dispatch
  } = useReducer(reducer, initializeValue);
  const setCopyrights = useCallback(value => {
    dispatch({
      type: "add",
      value
    });
  }, []);
  const resetCopyrights = useCallback(() => {
    dispatch({
      type: "reset"
    });
  }, []);
  return /*#__PURE__*/_jsx(CopyrightsContext.Provider, {
    value: {
      copyrights,
      setCopyrights,
      resetCopyrights
    },
    children: children
  });
}
function Copyrights() {
  const router = useRouter();
  const {
    copyrights,
    resetCopyrights
  } = useContext(CopyrightsContext);
  useEffect(() => {
    const handleHistoryChange = () => {
      resetCopyrights();
    };
    router.events.on("routeChangeStart", handleHistoryChange);
    router.events.on("hashChangeStart", handleHistoryChange);
    return () => {
      router.events.off("routeChangeStart", handleHistoryChange);
      router.events.off("hashChangeStart", handleHistoryChange);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles.copyrights,
    children: /*#__PURE__*/_jsx("p", {
      className: styles.list,
      children: copyrights.map((c, i) => /*#__PURE__*/_jsx("span", {
        children: c
      }, `copyright-${i}`))
    })
  });
}
export default /*#__PURE__*/memo(Copyrights);